import React from 'react';
import { ManageReference } from '../ManageReference/ManageReference';
import { getAllCompensationsUrl } from '../../../helpers/constants';


export function ManageCompensations() {
	return (
		<ManageReference
			title="Управление компенсациями"
			endpoint={getAllCompensationsUrl}
			labels={{
				selectLabel: 'Гарантии и компенсации:',
				boxTitle: 'Параметры компенсации',
				createNew: '---Создать новую компенсацию---'
			}}
		/>
	);
}